import React, { useState } from 'react'
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };
  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_vo7weev",
        "template_1x6nr8m",
        "#myForm",
        "RnYOVlDPnYyYN8khd"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");
          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>
      <section
        className="breadcrumb-area"
        style={{ backgroundImage: "url(/images/breadcrumb/breadcrumb-bg.jpg)" }}
      >
        <div className="container-fluid text-center">
          <h1>CONTACT US</h1>
          <div className="breadcrumb-bottom">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="left pull-left">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <i className="fa fa-angle-right" aria-hidden="true" />
                      </li>
                      <li>CONTACT US</li>
                    </ul>
                  </div>
                  <div className="right pull-right">
                    <Link>
                      <i
                        className="fa fa-arrow-circle-o-right"
                        aria-hidden="true"
                      />
                      Get a Quote
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-v1-area" style={{ marginTop: "-40px" }}>
        <div className="container">
          <div className="sec-title text-center bold">
            <h2 style={{ textTransform: "capitalize" }}>Get Touch with Us</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="img-holder">
                <img src="images/resources/contact.jpg" alt="Awesome Image" />
              </div>
              <div className="contact-info">
                <div className="row">
                  {/*Start single item*/}
                  <div className="col-md-6">
                    <div className="single-item">
                      <div className="icon-holder">
                        <span className="flaticon-building" />
                      </div>
                      <div className="text-holder">
                        <h5>Address :</h5>
                        <p>
                          <a href="https://share.google/cAUsHA8e15KrWMLEb" style={{ color: "black" }}>
                            Pillar Number 143, # 49 & 50,<br /> 4th Floor, United Arcade,<br />  Attapur, Hyderabad,<br /> Telangana-500048
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/*End single item*/}
                  {/*Start single item*/}
                  <div className="col-md-6">
                    <div className="single-item">
                      <div className="icon-holder">
                        <span className="flaticon-technology" />
                      </div>
                      <div className="text-holder">
                        <h5>Contact :</h5>
                        <p><a href="tel:(+91) 800 800 9832" style={{ color: "black" }} className="text-body">(+91) 800 800 9832</a></p>
                      </div>
                    </div>
                  </div>
                  {/*End single item*/}
                  {/*Start single item*/}
                  <div className="col-md-6">
                    <div className="single-item">
                      <div className="icon-holder">
                        <span className="flaticon-new-email-outline" />
                      </div>
                      <div className="text-holder">
                        <h5>Email :</h5>
                        <p><a href="mailto:javid@spacedesignstudio.co.in" style={{ color: "black" }} className="text-body">javid@spacedesignstudio.co.in</a></p>
                      </div>
                    </div>
                  </div>
                  {/*End single item*/}

                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form-v1">
                <form
                  method="post" onSubmit={sendEmail} id="myForm"
                  name="contact_form"
                  action="inc/sendmail.php"

                >
                  <input
                    type="text"
                    name="from_name"
                    onChange={(e) => nameChange(e)}
                    required
                    value={name}
                    placeholder="Your Name*"
                  />
                  <input
                    type="email"
                    id="email"
                    name='email'
                    onChange={(e) => mailChange(e)}
                    value={mail}
                    required
                    placeholder="Enter Email*"
                  />
                  <input
                    type="text"
                    id="phone"
                    name='phone'
                    onChange={(e) => numberChange(e)}
                    value={number}
                    required
                    placeholder="Your Phone"
                  />
                  <textarea
                    placeholder="Your Message.."
                    onChange={(e) => massagesChange(e)}
                    name='massage'
                    value={massages}
                    required
                  />
                  
                  <button
                    className="thm-btn bg-cl-1"
                    type="submit"
                    data-loading-text="Please wait..."
                  >
                    send message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=Space Design Studio Attapur, Telangana 500048&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>

    </>
  );
};

export default ContactUs;
